import { Directive } from "vue";

/**
 *  This directive is used to create a placeholder for an input field
 *  and move it to the center if the input field is focused or has a value.
 *  This directive must be used only once in the base template.
 */
export const vInputText: Directive = {
    mounted: (el: HTMLInputElement) => {
        new InputTextDirective(el as HTMLInputElement);
    }
};

class InputTextDirective {
    private inputEl?: HTMLInputElement;
    private placeholderEl?: HTMLElement;

    constructor(private el: HTMLInputElement) {
        if (el) {
            this.inputEl = el;
            this.initInputEventHandlers();
            this.initPlaceholder();
            this.initState();
        }
    }
    private initInputEventHandlers(): void {
        this.inputEl?.addEventListener("change", this.onChangeValue.bind(this));
    }

    private initPlaceholder(): void {
        if (!this.inputEl) {
            return;
        }
        const placeholderValue = this.inputEl.getAttribute("placeholder");
        if (placeholderValue?.length) {
            // clear placeholder
            this.inputEl.setAttribute("placeholder", "");
            // move placeholder to absolute positioned element
            const placehEl = document.createElement("span");
            placehEl.classList.add("input-text-placeholder");
            placehEl.textContent = placeholderValue;
            const inputElRaw = this.inputEl;
            if (inputElRaw.parentNode) {
                inputElRaw.parentNode.insertBefore(
                    placehEl,
                    inputElRaw.nextSibling,
                );
                this.placeholderEl = placehEl;
                // add input event handlers for focus and blur
                inputElRaw.addEventListener("focus", this.onFocus.bind(this));
                inputElRaw.addEventListener("blur", this.onBlur.bind(this));
            }
        }
    }

    private initState(): void {
        this.onChangeValue();
        setTimeout(this.onChangeValue.bind(this), 60);
    }

    // -----------------------------------------------------------
    // Event handlers

    onChangeValue(): void {
        if (this.placeholderEl) {
            // only move placeholder to center if input is empty
            if (this.inputEl?.value.length === 0) {
                this.placeholderEl.classList.remove("ph-focus");
            } else {
                if (!this.placeholderEl.classList.contains("ph-focus")) {
                    this.placeholderEl.classList.add("ph-focus");
                }
            }
        }
    }

    onFocus(): void {
        if (this.placeholderEl) {
            if (!this.placeholderEl.classList.contains("ph-focus")) {
                this.placeholderEl.classList.add("ph-focus");
            }
        }
    }

    onBlur(): void {
        if (this.placeholderEl) {
            // only move placeholder to center if input is empty
            if (this.inputEl?.value.length === 0) {
                this.placeholderEl.classList.remove("ph-focus");
            }
        }
    }
}
